var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropDown = function SvgDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.575 15.811-3.4-3.689a.693.693 0 0 1 0-.922l.574-.6a.558.558 0 0 1 .426-.19.555.555 0 0 1 .425.19L4 13.2l2.4-2.6a.571.571 0 0 1 .851 0l.574.6a.693.693 0 0 1 0 .922l-3.4 3.689a.573.573 0 0 1-.851 0zM6.425 5.4 4 2.794 1.6 5.4a.554.554 0 0 1-.425.189A.557.557 0 0 1 .75 5.4l-.574-.6a.692.692 0 0 1 0-.922L3.575.19a.571.571 0 0 1 .851 0l3.4 3.689a.693.693 0 0 1 0 .922l-.574.6a.556.556 0 0 1-.425.189.484.484 0 0 1-.402-.19z"
  })));
};
export default SvgDropDown;